/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MaterialPriceFetchPointDto } from '../../models/material-price-fetch-point-dto';

export interface GetMongoDataMaterialPriceFetches$Params {
  fromDate: string;
  toDate: string;
  'X-API-Version'?: string;
}

export function getMongoDataMaterialPriceFetches(http: HttpClient, rootUrl: string, params: GetMongoDataMaterialPriceFetches$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MaterialPriceFetchPointDto>>> {
  const rb = new RequestBuilder(rootUrl, getMongoDataMaterialPriceFetches.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MaterialPriceFetchPointDto>>;
    })
  );
}

getMongoDataMaterialPriceFetches.PATH = '/api/mongo-data/material-price-fetches';
